import axios from "axios";

import { getRole } from '@/utils/router.js'

class Product {
    constructor() {
        this.url = `/api/v1/products`;
    }

    getUrlWithRole() {
        let url = '/api/v1/products';
        const role = getRole();

        if(role === 'supplier') {
            url = '/api/v1/supplier/products';
        }

        return url
    }

    get(id) {
        return axios.get(`${this.getUrlWithRole()}/${id}`);
    }

    create(product,) {
        return axios.post(this.getUrlWithRole(), product);
    }

    edit(product) {
        return axios.put(`${this.getUrlWithRole()}/${product.id}`, product);
    }

    saveImg(productId, images) {
        const formData = new FormData();
        images.forEach((file, index) => {
            formData.append(`images[${index}]`, file, file.name);
        });

        return axios.post(`${this.url}/${productId}/images`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
    }

    removePhoto(photoId) {
        return axios.delete(`/api/v1/images/${photoId}`);
    }
}

export default Product;
